export const LOAD_ACCOUNTS_LIST = 'LOAD_ACCOUNTS_LIST';
export const LOAD_ACCOUNTS_NAMES = 'LOAD_ACCOUNTS_NAMES';
export const ADD_ACCOUNT = 'ADD_ACCOUNT';
export const EDIT_ACCOUNT = 'EDIT_ACCOUNT';
export const DELETE_ACCOUNT = 'DELETE_ACCOUNT';
export const RESET_ACCOUNTS = 'RESET_ACCOUNTS';
export const ADD_ACCOUNT_WITHDRAW = 'ADD_ACCOUNT_WITHDRAW';
export const REQUEST_EXTERNAL_WALLET = 'REQUEST_EXTERNAL_WALLET';
export const LOAD_ACCOUNT_PAYOUTS = 'LOAD_ACCOUNT_PAYOUTS';
export const LOAD_ACCOUNT_PAYINS = 'LOAD_ACCOUNT_PAYINS';
